module.exports = __webpack_public_path__ + "static/media/menu_sr.0e810f06.png";